import LocomotiveScroll from "locomotive-scroll"

let scroll

export function initScroll() {
    scroll = new LocomotiveScroll()
    return scroll
}

export function destroyScroll() {
    scroll?.destroy()
    scroll = null
}

export function stopScroll() {
    scroll?.stop()
}

export function startScroll() {
    scroll?.start()
}
